<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-26 16:19:23
 * @LastEditTime : 2020-01-13 10:26:54
 * @LastEditors  : Please set LastEditors
 -->
<template>
  <el-dialog
    class="selfModal selfModal_youBtn"
    :modal="false"
    :title="userPermissionTypeDialog.promptTittle"
    :close-on-click-modal="false"
    :visible.sync="permissionDialog"
    :before-close="handleDialogClose"
    :width="dialogWidth"
    v-loading="loading"
  >
    <div
      v-if="userPermissionTypeDialog.promptType === 'permission'"
      style="width:100%;height:100%;"
      class="userPermissionType_wrapper"
    >
      <treeMenu
        :key="treeKey"
        ref="treeMenu"
        initId="0"
        :isCheckBoxInit="isCheckBoxInit"
        :checkStrictly="false"
        :showBox="true"
        :showArrow="false"
        :showShadow="false"
        loadStyle="menuTree"
        style="width:100%;"
      ></treeMenu>
    </div>
    <div
      class="userPerm"
      v-if="userPermissionTypeDialog.promptType === 'selectUser'"
    >
      <div class="heightTree2">
        <treeMenu
                :key="treeKey"
                ref="treeMenu"
                initId="0"
                :showBox="false"
                :showArrow="false"
                loadStyle="staticLoad"
                style="width:200px;dispaly:inline-block;height: 100%;"
                @nodeClick="getNodeId"
        ></treeMenu>
      </div>

      <div class="selectUser-right">
        <div class="selectUser-right_table">
          <div style="margin-bottom:10px;">
            用户名或姓名：
            <el-input
              v-model="userName"
              style="width:150px;margin-right:10px;"
              @keyup.enter.native="userSearch"
              clearable
            />
            <el-button type="primary" size="small " @click="userSearch()"
              ><i class="el-icon-search"></i><span>搜索</span>
            </el-button>
            <el-button size="small " @click="clearUserName()"
              ><i class="el-icon-refresh"></i><span>清空</span>
            </el-button>
          </div>
          <div>
            <div class="table_wrapper tableHeight2" >
              <!--<el-scrollbar style="height: 100%;">-->
                <el-table
                  border
                  class="table-border"
                  ref="multipleRoleUserTable"
                  :data="deptUserData"
                  tooltip-effect="dark"
                  stripe
                  height="100%"
                  style="width: 100%;min-height: 100%"
                  @selection-change="selectionChange"
                  @select="handleSelect"
                  @select-all="allSelectionChange"
                >
                  <el-table-column
                    type="selection"
                    width="55"
                    align="center"
                  ></el-table-column>
                  <el-table-column
                    type="index"
                    label="序号"
                    width="65"
                    align="center"
                  ></el-table-column>
                  <el-table-column
                    prop="username"
                    label="用户名"
                    align="center"
                    show-overflow-tooltip
                  >
                  </el-table-column>
                  <el-table-column
                    prop="name"
                    label="姓名"
                    align="center"
                    show-overflow-tooltip
                  >
                  </el-table-column>
                  <!-- <el-table-column
                    prop="type"
                    label="类型"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span v-if=""></span>
                      {{ dealRoleType(scope.row.type) }}
                    </template>
                  </el-table-column> -->
                </el-table>
              <!--</el-scrollbar>-->
            </div>
            <!-- 分页start -->
            <div
              v-if="selectUser.total > 0"
              class="pageDivS"
            >
              <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="UserCurrentChange"
                layout="total,sizes,prev, pager, next"
                :current-page.sync="selectUser.current"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="selectUser.pageSize"
                :total="selectUser.total"
              >
              </el-pagination>
            </div>
            <!-- 分页end -->
          </div>
        </div>
        <div class="selectUser-right_list ">
          <p class="head_title">已选用户</p>
          <div class="right_list_content">
            <el-scrollbar style="height: 100%;">
              <el-card class="box-card">
                <div
                  v-if="selectedUserListArr.length < 1"
                  style="text-align:center;color:#666;"
                >
                  暂无数据
                </div>
                <div
                  v-if="selectedUserListArr.length > 0"
                  v-for="(item, index) in selectedUserListArr"
                  :key="item.directorId || item.userId"
                  class="text item list_item"
                >
                  <span
                    v-if="Object.keys(item).includes('directorId')"
                    class="list_item_name"
                    >{{ item.directorName }}</span
                  >
                  <span
                    v-if="Object.keys(item).includes('userId')"
                    class="list_item_name"
                    >{{ item.userName || item.username }}</span
                  >
                  <span class="list_item_icon" @click="delSelectedUser(item)"
                    ><i class="el-icon-close"></i
                  ></span>
                </div>
              </el-card>
            </el-scrollbar>
          </div>
        </div>
      </div>
      <div
        v-if="userPermissionTypeDialog.promptType === 'selectUserType'"
        style="position:relative;height:100%;"
      >
        <treeMenu
          :key="treeKey"
          ref="treeMenu"
          initId="0"
          :showBox="true"
          :showArrow="false"
          loadStyle="staticLoad"
          style="width:30%;dispaly:inline-block;"
          @nodeClick="getNodeId"
        ></treeMenu>
        <div class="selectUser-right">
          <el-table
            border
            class="table-border"
            ref="multipleRoleUserType"
            :data="userTypes"
            stripe
            tooltip-effect="dark"
            style="width: 100%;"
            @selection-change="userTypeSelectionChange"
          >
            <el-table-column
              type="selection"
              width="55"
              align="center"
            ></el-table-column>
            <el-table-column
              type="index"
              label="序号"
              width="65"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="label"
              label="用户类型"
              align="center"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                {{ scope.row.label }}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        v-if="userPermissionTypeDialog.promptType === 'permission'"
        type="primary"
        @click="modifysubmit()"
        >更 新</el-button
      >
      <el-button
        v-if="userPermissionTypeDialog.promptType === 'selectUser'"
        type="primary"
        @click="updateRoleUser()"
        >确 认</el-button
      >
      <el-button
        v-if="userPermissionTypeDialog.promptType === 'selectUserType'"
        type="primary"
        @click="updateRoleUserType()"
        >确 认</el-button
      >
      <el-button @click="handleDialogClose">关 闭</el-button>
    </span>
  </el-dialog>
</template>
<script>
import {
  updateRolePermission,
  getDeptUser,
  getRoleUsers,
  getListRoleUsers,
  saveRoleUsers,
  getRoleUserTypes,
  saveRoleUserTypes
} from "@/api/system/role";
import {getListTableUrl} from '@/api/management/user';
import { dealRoleType, dealRoleTypeData, stringToArray } from "@/util/utils";
import { mapGetters, mapMutations } from "vuex";
import treeMenu from "@/components/treeMenu/index.vue";

export default {
  name: "userPermissionType",
  props: {
    type: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      userName: "",
      deptUserData: [],
      selectUser: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      chooseAll: false,
      multipleDeptUser: [],
      preMultipleDeptUser: [],
      currentDeptId: 1,
      selectedRoleUsers: [],
      // selectedRoleUsersArray: [],
      userTypeChecked: [],
      utypesArray: [],
      treeKey: Date.parse(new Date()),
      dealRoleType: dealRoleType,
      dealRoleTypeData: dealRoleTypeData,
      stringToArray: stringToArray,
      dialogWidth: "500px",
      isCheckBoxInit: true,
      selectedUserListArr: [],
      loading: false,
    };
  },
  components: { treeMenu },
  computed: {
    ...mapGetters([
      "userPermissionTypeDialog",
      "permissionDialog",
      "checkedArray",
      "userTypes"
    ])
  },
  watch: {
    permissionDialog(val) {
      this.treeKey = Date.parse(new Date());
      this.currentDeptId = 1;
      this.$store.commit("clearChecked");
      this.selectedRoleUsers = [];
      this.selectedUserListArr = [];
      this.selectUser.current = 1;
      console.log(333, this.selectUser.current);
      // this.selectedRoleUsersArray=[];
      if (val && this.userPermissionTypeDialog.promptType === "permission") {
        this.dialogWidth = "500px";
        this.isCheckBoxInit = true;
      }
      if (this.userPermissionTypeDialog.promptType !== "permission") {
        this.dialogWidth = "1050px";
      }
    }
  },
  created() {},
  methods: {
    ...mapMutations({
      setPermissionDialog: "setPermissionDialog",
      setDefaultChecked: "setDefaultChecked"
    }),
    handleDialogClose() {
      this.setPermissionDialog(false);
    },
    modifysubmit() {
      console.log(44, this.checkedArray);
      if (this.checkedArray.length < 1) {
        this.$message.error("未选择权限不能进行保存！");
        return;
      }
      const roleId = this.userPermissionTypeDialog.currentRoleId;
      const menuIds = this.checkedArray;
      let query = { roleId, menuIds };
      updateRolePermission(query).then(res => {
        if (res.data.code == 0) {
          this.$message.success("修改权限成功");
          this.$parent.getTableData();
          this.setPermissionDialog(false);
        }
      });
    },
    // updateRoleUser() {
    //   const roleId = this.userPermissionTypeDialog.currentRoleId;
    //   const deptId = this.currentDeptId;
    //   const all = this.chooseAll;
    //   const users = this.multipleDeptUser;
    //   saveRoleUsers({ roleId, deptId, all, users }).then(res => {
    //     if (res.data.code == 0) {
    //       this.$message.success("选择用户成功");
    //       this.setPermissionDialog(false);
    //     }
    //   });
    // },
    getNodeId(data) {
      this.currentDeptId = data.id;
      this.selectUser.current = 1;
      this.getDeptUserData();
    },
    userSearch() {
      this.selectUser.current = 1;
      this.getDeptUserData();
    },
    clearUserName() {
      this.userName = "";
      this.getDeptUserData();
    },
    handleSelect(selection, row) {
      console.log(row)
      this.multipleDeptUser = selection;
      // console.log(this.multipleDeptUser.length,this.preMultipleDeptUser.length)
      if (!selection.includes(row)) {
        const index = this.selectedRoleUsers.findIndex(
          e => e == String(row.userId)
        );
        this.selectedRoleUsers.splice(index, 1);
        this.selectedUserListArr.splice(index, 1);
        // console.log(index,this.selectedRoleUsers)
      } else {
        this.multipleDeptUser.forEach((item, index) => {
          if (!this.selectedRoleUsers.includes(String(item.userId))) {
            this.selectedRoleUsers.push(String(item.userId));
            this.selectedUserListArr.push(item);
          }
        });
      }
      // console.log("切换选择后",this.selectedRoleUsers)
    },
    selectionChange(val) {
      this.chooseAll && (this.chooseAll = false);
    },
    allSelectionChange(selection) {
      if (selection.length > 0) {
        this.chooseAll = true;
        selection.forEach((item, index) => {
          if (!this.selectedRoleUsers.includes(String(item.userId))) {
            this.selectedRoleUsers.push(String(item.userId));
            this.selectedUserListArr.push(item);
          }
        });
      } else {
        this.chooseAll = false;
        this.deptUserData.forEach((item, index) => {
          const filterIndex = this.selectedRoleUsers.findIndex(e => {
            return e == item.userId;
          });
          this.selectedRoleUsers.splice(filterIndex, 1);
          this.selectedUserListArr.splice(filterIndex, 1);
        });
      }
      console.log(
        999,
        this.selectedUserListArr,
        selection,
        this.selectedRoleUsers
      );
    },
    UserCurrentChange(val) {
      this.selectUser.current = val;
      this.getDeptUserData();
    },
    handleSizeChange(val) {
      this.selectUser.pageSize = val;
      this.getDeptUserData();
    },
    // 删除被选中的用户
    delSelectedUser(row) {
      // console.log("删除用户：",row)
      const selectIndex = this.selectedUserListArr.findIndex(e => e === row);
      this.selectedRoleUsers.splice(selectIndex, 1);
      this.selectedUserListArr.splice(selectIndex, 1);
      const rowId = row.directorId || row.userId;
      this.deptUserData.forEach(item => {
        if (item.userId == rowId) {
          this.$refs.multipleRoleUserTable.toggleRowSelection(item, false);
        }
      });
    },
    getRoleUsersData() {
      const roleId = this.userPermissionTypeDialog.currentRoleId;
      this.loading = true
      getListRoleUsers({ roleId }).then(res => {
        if (res.data.code == 0) {
          const data = res.data.data;
          const idArr = data.map(item => {
            return String(item.userId);
          });
          this.selectedRoleUsers = idArr;
          this.selectedUserListArr = data;
          // this.selectedRoleUsersArray = res.data.data;
          this.getDeptUserData();
        }
      }).catch(() => {
        this.loading = false
      });
    },
    getDeptUserData() {
      const current = this.selectUser.current;
      const size = this.selectUser.pageSize;
      const deptId = this.currentDeptId;
      const type = this.type == 0 ? 2 : 0;
      let params = { current, size, deptId, type };
      if (this.userName) {
        params.userName = this.userName;
      }
      getListTableUrl(params).then(res => {
        if (res.data.code == 0) {
          this.deptUserData = res.data.data.records;
          this.selectUser.total = res.data.data.total;
          this.$nextTick(() => {
            this.deptUserData.forEach(row => {
              if (this.selectedRoleUsers.includes(String(row.userId))) {
                this.$refs.multipleRoleUserTable.toggleRowSelection(row, true);
              }
            });
          });
        }
      }).finally(() => {
        this.loading = false
      });
    },
    updateRoleUser() {
      const roleId = this.userPermissionTypeDialog.currentRoleId;
      const deptId = this.currentDeptId;
      const all = this.chooseAll;
      // const users = this.multipleDeptUser;
      const users = this.selectedRoleUsers;
      if (users.length < 1) {
        this.$message.closeAll();
        this.$message.warning("请选择用户");
        return;
      }
      saveRoleUsers({ roleId, deptId, all, users }).then(res => {
        if (res.data.code == 0) {
          this.$message.success("选择用户成功");
          this.setPermissionDialog(false);
        }
      });
    },
    userTypeSelectionChange(val) {
      const selectedArray = val.map(item => {
        return item.value;
      });
      this.userTypeChecked = [].concat(selectedArray);
    },
    getRoleUserTypesData() {
      const roleId = this.userPermissionTypeDialog.currentRoleId;
      getRoleUserTypes({ roleId }).then(res => {
        // console.log("获取用户角色类型数据:", res);
        if (res.data.code == 0) {
          // this.depIdsArray = res.data.data.depIds;
          this.utypesArray = res.data.data.utypes;
          this.$nextTick(() => {
            this.userTypes.forEach(row => {
              const checked = this.utypesArray.includes(String(row.value))
                ? true
                : false;
              this.$refs.multipleRoleUserType.toggleRowSelection(row, checked);
            });
            this.setDefaultChecked(res.data.data.depIds);
          });
        }
      });
    },
    updateRoleUserType() {
      const roleId = this.userPermissionTypeDialog.currentRoleId;
      const deptIds = this.checkedArray.join(",");
      const usertypes = this.userTypeChecked.join(",");
      // console.log(111, this.checkedArray);
      if (this.checkedArray.length < 1) {
        this.$message.closeAll();
        this.$message.warning("请选择部门");
        return;
      }
      if (this.userTypeChecked.length < 1) {
        this.$message.closeAll();
        this.$message.warning("请选择用户类型");
        return;
      }
      saveRoleUserTypes({ roleId, deptIds, usertypes }).then(res => {
        // console.log("保存用户类型数据：", res);
        if (res.data.code == 0) {
          this.$message.success("修改用户类型成功");
          this.setPermissionDialog(false);
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
// .userPermissionType_wrapper {
.selfModal {
    //newNZ
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    .el-dialog {
        min-height: 20vh;
        max-height: 83vh;
        margin: 0 !important;
        //margin-top: 5vh;
        overflow: auto;
        .el-dialog__body {
            max-height: 65vh !important;
            min-height: 25vh !important;
            padding-bottom: 10px;
            overflow: auto;
            .tableHeight_40 {
                height: 40vh !important;
                width: 100%;
            }
            .tableHeight2 {
                height: 45vh !important;
                width: 100%;
            }
            .heightTree2 {
                height: 58vh !important;
            }
            .tableHeight3 {
                height: 55vh !important;
                width: 100%;
            }
        }
        .el-dialog__footer {
            padding: 10px 0;
            padding-right: 20px !important;
        }
    }
}
.userPerm{
  display:flex;
  align-items: flex-start;
  overflow: auto;
  .selectUser-right {
    /*width: calc(100% - 250px);*/
    height: 58vh;
    display: flex;
    box-sizing: border-box !important;
    width: calc(100% - 210px)!important;
    .table_wrapper {
      width: 100%;
      overflow: auto;
      /*border: 1px solid #eaeef6;*/
    }
    .el-card {
      border: none;
    }
    .el-card.is-always-shadow {
      box-shadow: none;
    }
    &_table {
      flex: 1;
      overflow: hidden;
      box-sizing: border-box;
      margin: 0 10px;
    }
    &_list {
      width: 180px;
      /*height: 100%;*/
      // height: 425px;
      box-sizing: border-box;
      .right_list_content {
        height: calc(100% - 50px);
        box-shadow: 0 0 10px 0 #e4e7ed !important;
        margin-right: 10px;
        padding-bottom: 15px;
        border-radius: 5px;
      }
    }
    .list_item {
      display: flex;
      justify-content: space-between;
      &_name {
        width: 140px;
        padding-right: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      &_icon {
        width: 20px;
      }
      &_icon:hover {
        color: red;
      }
    }
    .head_title {
      height: 30px;
      line-height: 30px;
      color: #333;
      margin-bottom: 10px;
    }
    .text {
      font-size: 14px;
    }
    .item {
      padding: 0 15px;
      line-height: 30px;
      cursor: pointer;
    }
    .item:hover {
      background-color: #f5f7fa;
    }
    // }
  }

}




</style>
